<div class="notifications-page page">
  <app-table
    #notificationTable
    [columns]="notificationColumns"
    [endpoint]="apiNotificationsPath"
    [sortBy]="'createdOn'"
    [sortDirection]="'desc'"
    [actionColumnStyleClass]="'mediumWidth'"
    [rowActions]="['isRead']"
    [showTooltipText]="true"
    [tableTooltipText]="'myWorkspaceNotificationsTable'" />
</div>
